import React from "react";
import {
  Header,
  LogoSection,
  WindSongFooter
} from "../components";
function DestinationHorseShoeBayPeelIsland() {
  return (
    <div className="text-gray-600">
      <Header />
      <LogoSection />
        <h1 className="text-center text-5xl mt-48">DestinationHorseShoeBayPeelIsland Page</h1>
      <WindSongFooter />
    </div>
  );
}

export default DestinationHorseShoeBayPeelIsland;

